/* 2A Growth Readiness Audit
   Questions: edit the DATA array below. Each item has a title (t) and detail (d);
   either can be a plain string or {local, ecom} for the two operation types. */
(function () {
  var root = document.getElementById('gr-root');
  if (!root) return;

  var DATA = [
    { stage: 'Getting Found', title: 'Can new customers find you?',
      intro: "Mainstream reach channels throttle this industry. Discovery has to be built on channels that can't reject you.",
      items: [
        { t: 'Organic social content system',
          d: { local: 'Content pillars and a posting cadence: education, range culture, identity. Not just inventory photos.',
               ecom: 'Content pillars and a posting cadence: education, entertainment, identity. Not just product photos.' } },
        { t: { local: 'Google Business Profile fully built out', ecom: 'On-page SEO on your money pages' },
          d: { local: 'Claimed, categorized, photos current, posts active, and a system generating new reviews every week.',
               ecom: 'Titles, descriptions, and content targeting the buying-intent keywords the big-box retailers ignore.' } },
        { t: 'Compliant paid advertising setup',
          d: 'A properly structured ad account with creative that passes review, plus sub-brand architecture if your category needs it.' },
        { t: { local: 'Local partnership network', ecom: 'Industry and creator relationships' },
          d: { local: 'Active referral relationships with instructors, clubs, LE, and complementary businesses in your area.',
               ecom: 'Podcast sponsorships, creator partnerships, or industry site placements actively sending you traffic.' } },
        { t: 'You know your top acquisition channels',
          d: 'You can name your top 3 sources of new customers and roughly what each one costs you.' },
        { t: "A positioning that isn't just price",
          d: { local: 'A clear answer to why someone drives past two other shops to get to yours.',
               ecom: 'A clear answer to why someone buys from you instead of the cheapest listing on a marketplace.' } }
      ] },
    { stage: 'Staying in Touch', title: 'Do you keep them after the first visit?',
      intro: 'This is where most tactical brands are weakest. They earn attention, then let it evaporate.',
      items: [
        { t: 'Active list-capture mechanism',
          d: { local: 'In-store QR capture, counter signup, or a compliant sweepstakes actively converting foot traffic into contacts.',
               ecom: 'A compliant sweepstakes, lead magnet, or quiz actively converting traffic into contacts. Not just a footer form.' } },
        { t: 'Real email platform with deliverability configured',
          d: 'A proper email platform (Klaviyo-class) with SPF, DKIM, and DMARC set up so your email actually lands in the inbox.' },
        { t: 'Welcome flow, 5+ emails',
          d: 'An automated sequence that builds trust and identity, not just a one-time coupon.' },
        { t: 'Tracking and retargeting infrastructure',
          d: { local: 'Pixel and server-side tracking installed and verified, retargeting audiences built and ready.',
               ecom: 'Pixel and Conversions API installed and verified, retargeting audiences built and ready.' } },
        { t: 'Proof assets collected and displayed',
          d: { local: 'Reviews, testimonials, and customer photos visible where new customers make decisions.',
               ecom: 'Reviews, customer photos, and testimonials on product pages, not buried on a reviews tab.' } },
        { t: 'Basic segmentation',
          d: { local: 'Contacts tagged by interest: range members vs. buyers vs. class students. Not one giant blast list.',
               ecom: 'Contacts tagged by interest and behavior: buyers vs. prospects, category interest. Not one giant blast list.' } }
      ] },
    { stage: 'Closing the Sale', title: 'Do lookers turn into buyers?',
      intro: 'Attention and trust mean nothing if the last three feet are broken.',
      items: [
        { t: { local: 'Conversion-ready local presence', ecom: 'Fast, mobile-first website' },
          d: { local: 'Click-to-call, hours, directions, and booking front and center. A stranger can act in under 10 seconds.',
               ecom: "Loads fast on a phone, clear navigation, and a checkout that doesn't fight the customer." } },
        { t: '2A-friendly payment processing locked in',
          d: "A processor that knows exactly what you sell and won't pull the plug mid-month." },
        { t: { local: 'Follow-up on every missed opportunity', ecom: 'Abandonment flows running' },
          d: { local: 'Missed-call text-back, quote follow-up, and booking reminders. No lead dies in a voicemail box.',
               ecom: 'Cart, browse, and checkout abandonment emails running automatically.' } },
        { t: 'Real offer architecture',
          d: { local: "Entry offers, class-to-membership ladders, bundles, financing. Products aren't offers.",
               ecom: "Entry offers, bundles, financing options (Credova-class). Products aren't offers." } },
        { t: { local: 'Counter staff trained to capture and convert', ecom: 'FFL, shipping, and legal handled cleanly' },
          d: { local: 'Every walk-in gets asked for contact info and offered the next step. The counter is your checkout page.',
               ecom: 'FFL transfer process, shipping restrictions, and legal language clear before checkout, not after a support ticket.' } },
        { t: 'You know your conversion rate',
          d: { local: 'You know roughly what percentage of walk-ins and calls become customers.',
               ecom: 'You know your site conversion rate and watch it monthly.' } }
      ] },
    { stage: 'Repeat Business', title: 'Do they come back and bring friends?',
      intro: 'Ammo, consumables, range time, and training are repeat-purchase businesses. Most are run like one-time-sale businesses.',
      items: [
        { t: 'Post-purchase flow',
          d: { local: 'Automated follow-up after every sale or class: thank you, cross-sell, next step.',
               ecom: 'Automated onboarding, cross-sell, and replenishment sequences after every order.' } },
        { t: 'Consistent segmented campaign calendar',
          d: { local: 'At least one email per week to your list, segmented by interest. Not batch-and-blast.',
               ecom: 'At least one email per week to your list, segmented by interest and behavior. Not batch-and-blast.' } },
        { t: 'SMS program (where compliant)',
          d: { local: 'Opted-in SMS for events, restocks, and time-sensitive offers.',
               ecom: 'Opted-in SMS for restocks, drops, and time-sensitive offers.' } },
        { t: 'Recurring revenue mechanism',
          d: { local: 'Range memberships, training subscriptions, or VIP tiers turning customers into monthly revenue.',
               ecom: 'Subscriptions, VIP tiers, or auto-replenishment turning customers into monthly revenue.' } },
        { t: 'Automated review generation',
          d: { local: 'Every happy customer gets asked for a Google review, automatically.',
               ecom: 'Every delivered order triggers a review request, automatically.' } },
        { t: 'Referral program with a real incentive',
          d: { local: 'Customers have a concrete reason to bring their buddy in, and staff mention it.',
               ecom: 'Customers have a concrete reason to share, and the program is visible after purchase.' } }
      ] },
    { stage: 'Bulletproofing', title: 'Could you survive a ban tomorrow?',
      intro: "No generic marketing audit covers this section. In this industry, it's the difference between a bad month and a dead business.",
      items: [
        { t: 'Your email list is your largest channel, and growing',
          d: 'More owned contacts than social followers, with net list growth every month.' },
        { t: 'Ad account and page redundancy',
          d: 'Backup pages, ad accounts, and business manager access ready before you need them.' },
        { t: 'Backup payment processor identified',
          d: "If your processor drops you Friday at 5pm, you know exactly who you're calling Monday." },
        { t: 'Customer data exported and owned',
          d: 'Your customer list lives in a file you control, not trapped inside one platform.' },
        { t: 'No single channel over half your revenue',
          d: "If any one platform or channel disappeared tomorrow, you'd still be profitable." },
        { t: 'Compliance documentation in order',
          d: "Sweepstakes rules, advertising claims, and promotions all vetted. You're not one complaint from a shutdown." }
      ] }
  ];

  var CLASSES = [
    { min: 26, code: 'R-1', label: 'Full Mission Capable' },
    { min: 19, code: 'R-2', label: 'Mission Capable, Gaps Present' },
    { min: 11, code: 'R-3', label: 'Limited Capability' },
    { min: 0,  code: 'R-4', label: 'Not Mission Capable' }
  ];
  var TOTAL = DATA.reduce(function (n, s) { return n + s.items.length; }, 0);
  var STORE_KEY = 'gr-audit-v1';
  var mode = 'local';
  var answers = {};

  function $(id) { return document.getElementById(id); }
  function txt(v) { return typeof v === 'string' ? v : v[mode]; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ mode: mode, answers: answers })); } catch (e) {} }
  function load() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (s && s.answers) { answers = s.answers; mode = s.mode === 'ecom' ? 'ecom' : 'local'; }
    } catch (e) {}
  }

  function render() {
    var list = $('gr-checklist'), idx = $('gr-idx');
    if (!list) return;
    list.innerHTML = '';
    if (idx) idx.innerHTML = '';
    DATA.forEach(function (sec, si) {
      var el = document.createElement('section');
      el.className = 'gr-sec';
      el.id = 'gr-sec-' + si;
      var html = '<div class="gr-sec-head"><div class="eyebrow">Section ' + pad(si + 1) + '</div>' +
        '<span class="count" id="gr-count-' + si + '">0/' + sec.items.length + '</span>' +
        '<span class="stage-big">' + esc(sec.stage) + '</span><h2>' + esc(sec.title) + '</h2></div>' +
        '<p class="gr-sec-intro">' + esc(sec.intro) + '</p>';
      sec.items.forEach(function (item, ii) {
        var key = si + '-' + ii, cur = answers[key], title = txt(item.t);
        html += '<div class="gr-item' + (cur === 'yes' ? ' yes' : '') + '" data-key="' + key + '">' +
          '<span class="gr-item-num">' + (si + 1) + '.' + (ii + 1) + '</span>' +
          '<span class="gr-item-body"><strong>' + esc(title) + '</strong><span class="detail">' + esc(txt(item.d)) + '</span></span>' +
          '<span class="gr-dials" role="radiogroup" aria-label="' + esc(title) + '">' +
            '<label class="gr-dial v-yes' + (cur === 'yes' ? ' on' : '') + '"><input type="radio" name="q-' + key + '" value="yes"' + (cur === 'yes' ? ' checked' : '') + '><span class="ring"></span>Yes</label>' +
            '<label class="gr-dial v-no' + (cur === 'no' ? ' on' : '') + '"><input type="radio" name="q-' + key + '" value="no"' + (cur === 'no' ? ' checked' : '') + '><span class="ring"></span>No</label>' +
          '</span></div>';
      });
      el.innerHTML = html;
      list.appendChild(el);

      if (idx) {
        var a = document.createElement('a');
        a.href = '#gr-sec-' + si;
        a.innerHTML = '<span>' + pad(si + 1) + ' &middot; ' + esc(sec.stage) + '</span><span class="n" id="gr-idx-count-' + si + '">0/' + sec.items.length + '</span>';
        idx.appendChild(a);
      }
    });
    update();
  }

  function buildTicks() {
    var t = $('gr-ticks');
    if (!t) return;
    t.innerHTML = '';
    for (var i = 0; i < TOTAL; i++) { var d = document.createElement('div'); d.className = 't'; t.appendChild(d); }
  }

  function scoreNow() { return Object.keys(answers).filter(function (k) { return answers[k] === 'yes'; }).length; }
  function classFor(score) { for (var i = 0; i < CLASSES.length; i++) { if (score >= CLASSES[i].min) return CLASSES[i]; } return CLASSES[3]; }

  function update() {
    var score = scoreNow(), cls = classFor(score);
    $('gr-score').textContent = score;
    $('gr-score-m').textContent = score;
    DATA.forEach(function (sec, si) {
      var c = 0;
      sec.items.forEach(function (_, ii) { if (answers[si + '-' + ii] === 'yes') c++; });
      var a = $('gr-count-' + si), b = $('gr-idx-count-' + si);
      if (a) a.textContent = c + '/' + sec.items.length;
      if (b) b.textContent = c + '/' + sec.items.length;
    });
    var ticks = document.querySelectorAll('#gr-ticks .t');
    for (var i = 0; i < ticks.length; i++) {
      ticks[i].classList.toggle('on', i < score);
      ticks[i].classList.toggle('hot', i < score && cls.code === 'R-1');
    }
    $('gr-stamp-code').textContent = cls.code;
    $('gr-stamp-name').textContent = cls.label;
    $('gr-class-m').textContent = cls.code + ' · ' + cls.label;
    var rows = document.querySelectorAll('.gr-class-row');
    for (var r = 0; r < rows.length; r++) rows[r].classList.toggle('active', Number(rows[r].getAttribute('data-min')) === cls.min);
  }

  function setMode(m) {
    mode = m;
    $('gr-btn-local').setAttribute('aria-pressed', String(m === 'local'));
    $('gr-btn-ecom').setAttribute('aria-pressed', String(m === 'ecom'));
    save();
    render();
  }

  /* one delegated listener for all Yes/No dials */
  $('gr-checklist').addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.type !== 'radio') return;
    var row = inp.closest('.gr-item');
    if (!row) return;
    answers[row.getAttribute('data-key')] = inp.value;
    row.classList.toggle('yes', inp.value === 'yes');
    var dials = row.querySelectorAll('.gr-dial');
    for (var i = 0; i < dials.length; i++) dials[i].classList.toggle('on', dials[i].querySelector('input').checked);
    save();
    update();
  });
  $('gr-btn-local').addEventListener('click', function () { setMode('local'); });
  $('gr-btn-ecom').addEventListener('click', function () { setMode('ecom'); });

  /* ---------- results ---------- */
  function buildResults() {
    var score = scoreNow(), cls = classFor(score), gaps = [];
    var sections = DATA.map(function (sec, si) {
      var c = 0;
      sec.items.forEach(function (item, ii) {
        if (answers[si + '-' + ii] === 'yes') c++;
        else gaps.push((si + 1) + '.' + (ii + 1) + ' ' + txt(item.t) + (answers[si + '-' + ii] ? '' : ' (skipped)'));
      });
      return { name: sec.stage, yes: c, total: sec.items.length };
    });
    return {
      score: score, total: TOTAL, classification: cls.code, classification_label: cls.label,
      sections: sections, gaps: gaps, answered: Object.keys(answers).length,
      operation_type: mode === 'local' ? 'Local / Retail' : 'E-Commerce'
    };
  }

  function sendKlaviyo(r, email, firstName, business, optin) {
    var key = root.getAttribute('data-klaviyo-key');
    if (!key || !window.fetch) return;
    var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
    var profileAttrs = { email: email };
    if (firstName) profileAttrs.first_name = firstName;
    if (business) profileAttrs.organization = business;
    profileAttrs.properties = {
      'GR Score': r.score, 'GR Total': r.total,
      'GR Rating': r.classification + ' ' + r.classification_label,
      'GR Operation Type': r.operation_type,
      'GR Gap Count': r.gaps.length,
      'GR Last Completed': new Date().toISOString()
    };
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: headers, keepalive: true,
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: {
            score: r.score, total: r.total, classification: r.classification,
            classification_label: r.classification_label, sections: r.sections, gaps: r.gaps,
            answered: r.answered, operation_type: r.operation_type, business: business || ''
          },
          metric: { data: { type: 'metric', attributes: { name: root.getAttribute('data-metric') } } },
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        } } })
      });
      var list = root.getAttribute('data-klaviyo-list');
      if (optin && list) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST', headers: headers, keepalive: true,
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } })
        });
      }
    } catch (e) { /* Klaviyo is optional; the Shopify form still goes through */ }
  }

  var form = $('gr-form');
  if (form && $('gr-submit')) {
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[name="contact[website_hp]"]');
      if (hp && hp.value) { e.preventDefault(); return; }
      var email = ($('gr-email').value || '').trim();
      var name = ($('gr-name').value || '').trim();
      var biz = ($('gr-biz').value || '').trim();
      var status = $('gr-status');
      if (!email || !$('gr-email').checkValidity()) {
        e.preventDefault();
        status.className = 'gr-cap-status err';
        status.textContent = 'Enter a valid email so we can send your results.';
        $('gr-email').focus();
        return;
      }
      var r = buildResults();
      if (r.answered < r.total && !form.getAttribute('data-confirmed')) {
        e.preventDefault();
        form.setAttribute('data-confirmed', '1');
        status.className = 'gr-cap-status err';
        status.textContent = 'You answered ' + r.answered + ' of ' + r.total + '. Skipped items count as No. Press the button again to send anyway.';
        return;
      }
      var lines = [
        '2A GROWTH READINESS AUDIT SUBMISSION',
        'Name: ' + (name || '(not given)'),
        'Email: ' + email,
        'Business: ' + (biz || '(not given)'),
        'Phone: ' + ((($('gr-phone') || {}).value || '').trim() || '(not given)'),
        'Operation type: ' + r.operation_type,
        'Score: ' + r.score + '/' + r.total + ' (' + r.classification + ' ' + r.classification_label + ')',
        'Items answered: ' + r.answered + ' of ' + r.total,
        'Email updates opt-in: ' + ($('gr-optin').checked ? 'YES' : 'no'),
        '',
        'SECTION BREAKDOWN:'
      ];
      r.sections.forEach(function (s) { lines.push('- ' + s.name + ': ' + s.yes + '/' + s.total); });
      lines.push('', 'GAPS (answered No or skipped):');
      if (r.gaps.length) r.gaps.forEach(function (g) { lines.push('- ' + g); }); else lines.push('- None. Full sweep.');
      lines.push('', 'ITEM ROW (1.1 to 5.6, Y/N/-):');
      var row = [];
      DATA.forEach(function (sec, si) { sec.items.forEach(function (_, ii) { var v = answers[si + '-' + ii]; row.push(v === 'yes' ? 'Y' : v === 'no' ? 'N' : '-'); }); });
      lines.push(row.join(','));

      $('gr-body').value = lines.join('\n');
      $('gr-f-score').value = r.score + '/' + r.total;
      $('gr-f-rating').value = r.classification + ' ' + r.classification_label;
      $('gr-f-type').value = r.operation_type;
      try { sessionStorage.setItem(STORE_KEY + '-result', JSON.stringify({ score: r.score, total: r.total, code: r.classification, label: r.classification_label })); } catch (err) {}

      sendKlaviyo(r, email, name, biz, $('gr-optin').checked);
      $('gr-submit').disabled = true;
      $('gr-submit').textContent = 'Sending...';
      /* let the native Shopify form submit continue */
    });
  }

  /* after a successful post, show the score they sent and jump to the confirmation */
  var done = $('gr-done');
  if (done) {
    try {
      var res = JSON.parse(sessionStorage.getItem(STORE_KEY + '-result') || 'null');
      if (res) {
        var p = document.createElement('p');
        p.className = 'sub';
        p.innerHTML = 'You scored <b>' + res.score + '/' + res.total + '</b>, rated <b>' + esc(res.code) + ' ' + esc(res.label) + '</b>.';
        done.insertBefore(p, $('gr-done-text'));
      }
    } catch (e) {}
    setTimeout(function () { $('gr-capture').scrollIntoView({ block: 'start' }); }, 50);
  }

  load();
  $('gr-btn-local').setAttribute('aria-pressed', String(mode === 'local'));
  $('gr-btn-ecom').setAttribute('aria-pressed', String(mode === 'ecom'));
  buildTicks();
  render();
})();